import { CharlieSpinner } from '@ver.id/libs.ui.charlie';
import EmbeddedCardLayout from '../../../components/embedded/CardLayout';
import { useTranslation } from '../../../i18n/i18n';

/** While data or the next step loads. */
export default function EmbeddedSpinnerScreen() {
  const { t } = useTranslation();
  return (
    <EmbeddedCardLayout>
      <div className="flex justify-center">
        <CharlieSpinner
          role="status"
          aria-hidden={false}
          aria-label={t('app.loadingTitle')}
          className="text-brand-primary"
        />
      </div>
    </EmbeddedCardLayout>
  );
}
